// Copyright (c) 2021 Davide Gironi
// Please refer to LICENSE file for licensing information.

import React from 'react';
import { useTranslation } from 'react-i18next';

// import modules
import DefaultContainer from '../../modules/Containers/DefaultContainer';
import DefaultPageTitle from '../../modules/Containers/DefaultPageTitle';

export default function PagePrivacy() {
    const { t } = useTranslation('privacy', { keyPrefix: 'privacy' });

    return (
        <DefaultContainer>
            <DefaultPageTitle>{t('title')}</DefaultPageTitle>
            <div dangerouslySetInnerHTML={{ __html: t('content', { interpolation: { escapeValue: false } }) }} />
        </DefaultContainer>
    );
}
